import React from 'react'
import { SVGIconProps } from '../types'
const SvgAssistantNavigation = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M12 1C5.93 1 1 5.93 1 12s4.93 11 11 11 11-4.93 11-11S18.07 1 12 1m3.57 16L12 15.42 8.43 17l-.37-.37L12 7l3.95 9.63z" />
  </svg>
)
export default SvgAssistantNavigation
